import {
  Component,
  OnInit,
} from '@angular/core';
import { SignInApiService } from '../../services/sign-in-api/SignInApiService';
import { AccessService } from '../../../application/services/AccessService';
import { Router } from '@angular/router';
import { SignInFormData } from '../sign-in-form/sign-in-form.component';
import { RegistrationApiService } from '../../../registration/services/registration-api/RegistrationApiService';

@Component({
  selector: 'app-sign-in',
  standalone: false,
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.sass',
})
export class SignInComponent implements OnInit {
  public errorMessage: string | null = null;
  public registrationAvailable = false;

  public constructor(
    private signInApi: SignInApiService,
    private registrationApi: RegistrationApiService,
    private accessService: AccessService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    void this.loadRegistrationStatus();
  }

  public async signIn(data: SignInFormData): Promise<void> {
    this.errorMessage = null;
    const response = await this.signInApi.signIn(data);
    if (response.status === 'failed') {
      this.errorMessage = response.errorMessage;
    } else {
      this.accessService.authorize(response.response.accessToken);
      await this.router.navigate([
        '',
      ]);
    }
  }

  private async loadRegistrationStatus(): Promise<void> {
    try {
      const response = await this.registrationApi.getRegistrationStatus();
      this.registrationAvailable = response.status === 'successful' && response.response.available;
    } catch {
      this.registrationAvailable = false;
    }
  }

}
